function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  className: "main",
  d: "M563.46,799.53V765.74a9,9,0,0,0-9-9H533.76a9,9,0,0,0-9,9V805a2.1,2.1,0,0,0,.17.84,2.17,2.17,0,0,0,2,1.33h.45a2.09,2.09,0,0,1,.67.1,2.17,2.17,0,0,1,.86,3.59l-.46.46a2.16,2.16,0,0,0,0,3l3.77,3.77a2,2,0,0,0,1.11.59,2,2,0,0,0,.42,0,2.18,2.18,0,0,0,1.53-.63l.34-.35a2.17,2.17,0,0,1,3.59.86,2.09,2.09,0,0,1,.11.67v.23a2.37,2.37,0,0,0,.16.84,2.18,2.18,0,0,0,2,1.32h5.32a2.16,2.16,0,0,0,2.17-2.16,2.15,2.15,0,0,1,.1-.68,2.19,2.19,0,0,1,1.82-1.48,2.13,2.13,0,0,1,1.77.63l.12.12a2.08,2.08,0,0,0,1.12.59,2,2,0,0,0,.41,0,2.15,2.15,0,0,0,1.53-.63l3.77-3.77a2,2,0,0,0,.47-.71,2.1,2.1,0,0,0,0-1.63,2,2,0,0,0-.47-.71l-.46-.46a2.17,2.17,0,0,1,.86-3.59,2.09,2.09,0,0,1,.67-.1h.67a2.16,2.16,0,0,0,2-1.33,2.1,2.1,0,0,0,.17-.84v-5.32A.78.78,0,0,0,563.46,799.53Z",
  transform: "translate(-524.74 -756.72)"
});

function SvgFunky(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38.74 64.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunky);
export default __webpack_public_path__ + "static/media/funky.67580fa8.svg";
export { ForwardRef as ReactComponent };